// extracted by mini-css-extract-plugin
export default {"container":"HeaderText_container__n4FoX","captionFirst":"HeaderText_captionFirst__EVW6C"};